import React from 'react';
import { Provider } from 'react-redux';

import configureStore from '../../store/configureStore';
import InvestmentKpisContainer from '../../containers/investor/investments/InvestmentKpisContainer';


const InvestorKpis = props => (
  <Provider store={configureStore(props)}>
    <InvestmentKpisContainer />
  </Provider>
);

export default InvestorKpis;
